import { Component, EventEmitter, Input, Output } from '@angular/core';

import { UserRole } from 'app/core/authentication';

@Component({
  selector: 'kh-register-role-selector',
  styleUrls: ['./register-role-selector.component.less'],
  templateUrl: './register-role-selector.component.html',
  standalone: false
})
export class RegisterRoleSelectorComponent {
  public studentRole = UserRole.student;
  public teacherRole = UserRole.teacher;
  public parentRole = UserRole.parent;
  public selectedRole: UserRole | undefined = undefined;

  @Input() public hiddenRoles: UserRole[] = [];

  @Output() public roleSelected = new EventEmitter<UserRole>();

  public selectRole(role: UserRole): void {
    this.selectedRole = role;
    this.roleSelected.emit(role);
  }

  public isRoleVisible(role: UserRole): boolean {
    return !this.hiddenRoles.includes(role);
  }
}
